module.exports = __webpack_public_path__ + "images/emoji/hankey.d12d38e92a2adf59aa73.png";